import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("section", component(opts));
  editor.BlockManager.add("section", block(opts));
};